module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAK5JREFUeNpiYBgFo4BSwAhjlJaW/idFY3d3NyMx6phGw3j4xwEjuRqBPhYAUuuB2AEq9ACIC4E+20AtH8AMPwDEC4BYASQGtFgBWRELsXGAJczBhgPFHaH6DwKp+UCcAMQN1IqDBzjYmD4gNlWgGZgAdTmI3Q8Vv0CtOCiE0qBg2Q/EBlB+PTQBUGYBNLUoAnEjFAdCXW8AtZCyZIon6YIMvwB0QOJoOTY4AECAAQAE6jSpHKB9QAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/detail-view.png
// module id = 609
// module chunks = 0